import { Component, Input, OnInit } from '@angular/core';
import lgVideo from 'lightgallery/plugins/video'
import { MatDialog } from '@angular/material/dialog';
import { GalleryFormComponent } from './gallery-form/gallery-form.component';
import { GalleryService } from '../../../services/Gallary.service';
import { ActivatedRoute } from '@angular/router';
import { GalleryData, GalleryFile } from '../../../models/Gallery';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html'
})
export class GalleryComponent implements OnInit {
  @Input() restaurantId!: number;
  dataLoading = false;

  settings = {
    counter: true,
    plugins: [lgVideo],
    selector: '.view-btn',
    // videojs: true,
    // videojsOptions: {
    //   muted: true,
    // },
    // source: [
    //   {
    //     src: '/videos/video1.mp4',
    //     type: 'video/mp4',
    //   }
    // ],
    // tracks: [
    //   {
    //     src: '/videos/title.txt',
    //     kind: 'captions'
    //   }
    // ],
    // attributes: { preload: false, controls: true },
  };

  // Nav scrollable
  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider!: any;

  galleryData!: GalleryData;

  subscriptions: Subscription[] = []


  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private service: GalleryService,
    public translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    if (!this.restaurantId) {
      this.route.params.subscribe(params => {
        this.restaurantId = params['id'];
      });
    }
    this.getAll();
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAll();
        }
      })
    )
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  videoType(item: GalleryFile) {
    return JSON.stringify({
      "source": [
        {
          "src": item.filePath,
          "type": item.type.toLowerCase() + '/' + item.extension
        }
      ],
      "attributes": {
        "preload": false,
        "playsinline": true,
        "controls": true
      }
    })
  }

  getAll() {
    this.dataLoading = true;
    this.service.getAll(this.restaurantId).subscribe(
      (data) => {
        this.dataLoading = false;
        this.galleryData = data as GalleryData;
        setTimeout(() => {
          this.initSlider();
        }, 100);
      },
      (error: any) => {
        this.dataLoading = false;
      });
  }

  openForm() {
    const dialogRef = this.dialog.open(GalleryFormComponent, {
      width: '50rem',
      data: {
        galleryData: this.galleryData,
        restaurantId: this.restaurantId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll();
      }
    });
  }

  deleteRecord(recordId: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousureyouwanttodeletethisphoto/video?'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(this.restaurantId, recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.photodeletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll();
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }

  initSlider() {
    this.slider = document.querySelector<HTMLElement>('#gallery-slider');
  }
  startDragging(e?: any, flag?: any) {
    this.mouseDown = true;
    this.startX = e.pageX - this.slider!.offsetLeft;
    this.scrollLeft = this.slider!.scrollLeft;
  }
  stopDragging(e?: any, flag?: any) {
    this.mouseDown = false;
  }
  moveEvent(e?: any) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - this.slider!.offsetLeft;
    const scroll = x - this.startX;
    this.slider!.scrollLeft = this.scrollLeft - scroll;
  }

}
